<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        {{ cpname }}
      </div>

      <div class="f-right">
        <el-button
          icon="el-icon-plus"
          type="primary"
          @click="add"
          v-hasPermi="['wenwu:reportdetail:del']"
          >新增</el-button
        >
      </div>

      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <div class="ml20 f18 blue cursor" @click="$router.back()">
      <i class="el-icon-back"></i> 返回
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar"></div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column prop="num" label="序号" align="center">
          </el-table-column>
          <el-table-column
            prop="bg_company_name"
            label="单位名称

"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xm_baogao_name"
            label="报告名称

"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="xm_baogao_leixing"
            align="center"
            label="报告类型"
          >
          </el-table-column>
          <!-- <el-table-column
                            prop="role_value"
                            align="center"
                            label="系统角色">
                    </el-table-column> -->
          <el-table-column
            prop="xm_suoshu"
            label="所属项目

"
            v-if="false"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xm_baogao_time"
            align="center"
            label="报告上传时间"
          >
          </el-table-column>
          <el-table-column
            prop="xm_jiancha_user"
            align="center"
            label="检查人员"
            v-if="false"
          >
          </el-table-column>
          <!-- <el-table-column prop="ce" align="center" label="数据统计">
            <template slot-scope="scope">
              {{ $map.menuStatus[scope.row.status] }}
            </template>
          </el-table-column> -->
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                :to="{
                  path: '/report/detail',
                  query: { id: scope.row.xm_uuid },
                }"
                v-hasPermi="['wenwu:reportdetail:query']"
              >
                <el-button type="primary" size="mini" plain>详情</el-button>
              </router-link>
              <el-popconfirm
                title="确定执行此操作吗？"
                class="cursor"
                @onConfirm="changeStatus(scope.row)"
                @confirm="changeStatus(scope.row)"
                v-hasPermi="['wenwu:reportdetail:del']"
              >
                <a slot="reference">
                  <el-button type="danger" size="mini" plain>删除</el-button>
                </a>
              </el-popconfirm>

              <!--                            <el-popconfirm title="确定删除吗？" class="cursor" @onConfirm="changeStatus(scope.row,2)">-->
              <!--                                <a slot="reference" class="red">-->
              <!--                                    删除-->
              <!--                                </a>-->
              <!--                            </el-popconfirm>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="params.limit || 10"
        @current-change="pageChange"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="status == 1 ? '文件上传' : '修改'"
      :before-close="beforeClose"
      :visible.sync="showDia"
      :width="status == 1 ? '830px' : '500px'"
      ref="model"
      :close-on-click-modal="false"
    >
      <el-row :gutter="30" v-if="status == 1">
        <el-col :span="13">
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            label-width="80px"
            size="small"
          >
            <el-form-item label="单位名称" prop="basebg.bg_company_num">
              <el-select
                :disabled="isread"
                v-model="form.basebg.bg_company_num"
                filterable
                remote
                placeholder="请输入关键词"
                :loading="sloading"
              >
                <el-option
                  v-for="item in compList"
                  :key="item.c_company_num"
                  :label="item.c_name"
                  :value="item.c_company_num"
                ></el-option>
              </el-select>
              <!-- <el-button size="mini" @click="addUnit">新增社会单位</el-button> -->
            </el-form-item>
            <el-form-item
              label="项目名称"
              v-if="false"
              prop="xiangmubg.xm_suoshu"
            >
              <!-- <el-input v-model="form.xiangmubg.xm_suoshu"></el-input> -->

              <el-select
                disabled
                v-model="form.xiangmubg.xm_suoshu"
                filterable
                remote
                placeholder="请输入关键词"
                :loading="sloading"
              >
                <el-option
                  v-for="item in programList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="报告名称" prop="xiangmubg.xm_baogao_name">
              <el-input v-model="form.xiangmubg.xm_baogao_name"></el-input>
            </el-form-item> -->
            <el-form-item label="报告类型" prop="xiangmubg.xm_baogao_leixing">
              <el-select
                v-model="form.xiangmubg.xm_baogao_leixing"
                filterable
                clearable
              >
                <el-option
                  :label="item.mc_name"
                  :value="item.mc_id"
                  v-for="item in randomList"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="生成日期" prop="basebg.starttime">
              <el-date-picker
                v-model="form.basebg.starttime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="检查人员"
              v-if="false"
              prop="xiangmubg.xm_jiancha_user"
            >
              <!-- <el-input :value="tr_address" ></el-input>
               -->

              <!-- <el-select multiple="" v-model="form.tr_per">
                
               </el-select> -->
              <el-input v-model="form.xiangmubg.xm_jiancha_user"> </el-input>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-upload
                drag
                action="."
                :http-request="upload"
                multiple
                list-type="none"
                accept="*"
                :before-upload="beforeUpload"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11">
          <el-card class="upload-box">
            <el-scrollbar style="height: 440px">
              <ul class="file-list">
                <li v-for="item in fileList" class="align-center">
                  <img src="@/assets/img/base.png" alt="" />
                  <div class="flex1">
                    <div class="mb5" :title="item.name">{{ item.name }}</div>
                    <div class="mb5">
                      {{ (item.size / 1024 / 1024).toFixed(2) }}M
                    </div>
                    <el-progress
                      :percentage="+item.progress.toFixed(1)"
                    ></el-progress>
                  </div>
                  <i class="el-icon-close" @click="closeFile(item)"></i>
                </li>
              </ul>
            </el-scrollbar>
          </el-card>
        </el-col>
      </el-row>

      <!-- <el-form
        :model="editForm"
        :rules="rules1"
        ref="form1"
        label-width="80px"
        size="small"
        v-else
        v-loading="loading1"
      >
        <el-form-item label="单位名称">
          <el-input v-model="tr_address" disabled></el-input>
        </el-form-item>
        <el-form-item label="项目名称" prop="tr_project_name">
          <el-select
            v-model="editForm.tr_project_name"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            @change="changeS"
            :loading="sloading"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.unit_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报告名称">
          <el-input v-model="tr_address" disabled></el-input>
        </el-form-item>
        <el-form-item label="报告类型" prop="tr_undertaker">
          <el-select v-model="editForm.tr_undertaker">
            <el-option
              :label="item.tr_user_name"
              :value="item.tr_user_id"
              v-for="item in userList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报告生成日期" prop="tr_assist">
          <el-select v-model="editForm.tr_assist">
            <el-option
              :label="item.tr_user_name"
              :value="item.tr_user_id"
              v-for="item in userList"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form> -->

      <div class="center">
        <el-button
          type="primary"
          @click="formSubmit"
          size="small"
          :loading="isUpload"
          >提交</el-button
        >
        <!-- -->

        <el-button
          @click="
            beforeClose(() => {
              showDia = false;
            })
          "
          size="small"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">取消</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import OSS from "ali-oss";
import { getUserList, editUser } from "../../api/user";
import { get, post } from "@/utils/http.js";
export default {
  data() {
    return {
      list: [],
      params: {
        page: 1,
        xm_base_uuid: "",
        xm_baogao_name: "",
        xm_baogao_leixing: "",
        starttime: "",
        endtime: "",
        xm_suoshu: this.$route.query.id,
      },
      total: 0,
      id: this.$route.query.id,
      fileType: ["docx", "doc", "pdf"],

      showDia: false,
      searchForm: this.$getForm("userSearch"),
      editData: {},
      remoteFuncs: {},
      cpname: "",
      loading1: false,
      sloading: false,
      isread: false,
      tr_address: "",
      status: 1, //1新增 2修改
      count: 0,
      showDia: false,
      form: {
        basebg: {
          bg_company_num: "",
          starttime: "",
        },
        xiangmubg: {
          xm_baogao_name: "",
          xm_baogao_leixing: "",
          xm_suoshu: this.$route.query.id,
          xm_jiancha_user: "",
        },
        wenjianbg: [],
      },
      rules: {
        "basebg.bg_company_num": [
          { required: true, message: "请选择单位", trigger: "blur" },
        ],
        "xiangmubg.xm_suoshu": [
          { required: true, message: "请选择所属项目", trigger: "blur" },
        ],
        "xiangmubg.xm_baogao_name": [
          { required: true, message: "请填写报告名称", trigger: "blur" },
        ],
        "xiangmubg.xm_baogao_leixing": [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],

        "xiangmubg.xm_jiancha_user": [
          { required: true, message: "请填写检查人员", trigger: "blur" },
        ],
        "basebg.starttime": [
          { required: true, message: "请选择日期", trigger: "blur" },
        ],
      },

      list: [],
      editForm: {
        tr_project_name: "",
        tr_undertaker: "", //承办人
        tr_assist: "", //协办人
        tr_id: "",
        tr_is_case: "",
        tr_status: 2,
        tr_unit_num: "",
        tr_type: "",
      },
      sheng: [],
      shi: [],
      qu: [],
      hangye: [],
      userList: [],
      fileList: {},
      // lawList: [],
      // unitList: [],
      // userList_s: [],
      randomList: [],
      programList: [],
      // projectList: [],
      compList: [],
      canEditLength: false,
      loading: false,
    };
  },
  created() {
    this.getList();
    this.getCitys("sheng");
    // 获取所有社会单温
    this.$post("/dzda/allbase").then((res) => {
      this.compList = res.data;
    });
    this.$get("/trxf/main/sys/area/arealist").then((res) => {});
    // 查询报告类型
    this.$post("/devicemanage/mapcode", { mc_parent_id: 232 }).then((res) => {
      this.randomList = res.data;
    });
    // 查询省

    this.$post("/devicemanage/mapcode", { mc_parent_id: 66 }).then((res) => {
      this.hangye = res.data;
    });
    // 项目列表
    this.$post("/dzda/allxiangmu", this.params).then((res) => {
      this.programList = res.data;
    });
  },
  methods: {
    reset() {
      this.resetSearch();
      this.getList();
      this.showdia2 = false;
    },
    delVideo(it) {
      //删除视频
      editVideo({ tr_id: it.tr_id, tr_status: 0 }).then((res) => {
        this.$message({
                message: '修改成功',
                type: 'success',
                duration: 700,
              });
        // this.$message.success("修改成功");
        this.getVideoData();
        this.getList();
      });
    },
    cancle() {
      this.showDia = false;
      this.resetSearch();
    },
    changeStatus(it, del) {
      this.$post("/dzda/delxmbaogao", {
        xm_uuid: it.xm_uuid,
      }).then((res) => {
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        // this.$message.success("操作成功");
        this.getList();
      });
    },
    addUnit() {
      this.$router.push("/company/company-add");
    },
    changeUnit(val) {
      this.userList_s = [];
      getUser(val).then((res) => {
        this.userList_s = res.data || [];
      });
    },
    //  获取城市
    getCitys(name) {
      var url = "bg_suoshu_sheng";
      var Name = "bg_suoshu_shi";
      switch (name) {
        case "sheng":
          break;
        case "shi":
          url = "bg_suoshu_sheng";
          this.params.bg_suoshu_shi = "";
          this.params.bg_suoshu_qu = "";

          break;
        case "qu":
          url = "bg_suoshu_shi";
          Name = "bg_suoshu_qu";
          this.params.bg_suoshu_qu = "";

          break;
        default:
          false;
      }

      this.$post(`/dzda/${name}`, { area_code: this.params[url] || "" }).then(
        (res) => {
          this[name] = res.data;
        }
      );
    },
    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$post("/dzda/pingguxmbglist", this.params).then((res) => {
        this.cpname = res.basename;
        this.total = res.count;
        this.list = res.list;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params };
      this.getList();
    },
    beforeUpload(file) {
      // let testmsg = /^video\/(mp4|webm|ogg|ogv)$/.test(file.type)
      // if (!testmsg) {
      //     this.$message.error('暂不支持此视频格式上传!')
      //     return false
      // }
    },
    play(it) {
      this.$refs.video.open = true;
      var type = null;

      if (it.is_oss && it.is_oss == 1) {
        var name = it.tr_href.split("?")[0];
        if (/^.*\..*$/.test(name)) {
          type = name.split(".")[name.split(".").length - 1];
        }
        this.$refs.video.getDownUrl(
          it.tr_href,
          null,
          type,
          it.tr_length,
          it.is_oss
        );
      } else {
        var name = it.tr_href.split("?")[0];

        if (/^.*\..*$/.test(name)) {
          type = name.split(".")[name.split(".").length - 1];
        }
        this.$refs.video.getDownUrl1(
          it.tr_local_href,
          null,
          type,
          it.tr_length,
          it.is_oss
        );
      }
    },
    beforeClose(done) {
      if (this.isUpload) {
        this.$confirm("文件上传中，关闭将取消上传，是否取消", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            done();
            this.cancleUpload();
          })
          .catch(() => {});
      } else {
        done();
      }
    },
    cancleUpload() {
      console.log(this.fileList);
      this.fileList = {};
      this.form = {
        basebg: {
          bg_company_num: "",
        },
        xiangmubg: {
          xm_baogao_name: "",
          xm_baogao_leixing: "",
          xm_suoshu: "",
          xm_jiancha_user: "",
        },
        wenjianbg: [],
      };
    },
    changeCase(it) {
      //改变立案状态
      let obj = {
        tr_is_case: it.tr_is_case,
        tr_id: it.tr_id,
      };
      edit(obj)
        .then((res) => {
          // this.$message.success("修改是否立案成功");
          this.$message({
                message: '修改是否立案成功',
                type: 'success',
                duration: 700,
              });
        })
        .catch((err) => {});
    },
    closeFile(it) {
      //取消上传
      it.client.cancel();
      this.$delete(this.fileList, it.key);
    },
    upload(val) {
       if (!(val.file.name.indexOf("doc") > -1 || val.file.name.indexOf("docx") > -1 || val.file.name.indexOf("pdf") > -1 || val.file.name.indexOf("jpg") > -1 ||val.file.name.indexOf("png") > -1||val.file.name.indexOf("jpeg") > -1)) {
        this.$notify({
            title: "暂不支持该文件类型",
            // message: `${_this.fileList[id].name}上传完成`,
            type: "warning",
          });

        return
      }
      // let client = new OSS(this.$store.state.config.ossConfig);
      let file = val.file;
      let _this = this;
      let id =
        // this.$config.dangan +
        // "/t" +
        Date.now() +
        "s" +
        file.size +
        "/" +
        file.name;
      this.$set(this.fileList, id, {
        name: file.name,
        size: file.size,
        uploading: true,
        time: 0,
        progress: 0,
        key: id,
        url:''
        // client: client,
      });
       let formData = new FormData();
      console.log(formData, "formData");
      formData.append("file", file);
      console.log(formData, "formData1");
      // formData.append("title", this.title);
      this.getTimes(file, id);
      console.log(file, "file");
     
      this.$post("/common/upload", formData).then((res) => {
          this.fileList[id].progress = 100;
        this.fileList[id].uploading = false;
         this.fileList[id].url=res.data.url

         log(this.fileList,res, "res");
        // this.fileList.key=res.data.url
        this.$notify({
          title: "上传成功",
          message: `${this.fileList[id].name}上传完成`,
          type: "success",
        });
      });
      // 定义上传方法。
      // function multipartUpload() {
      //   _this.fileList[id].client
      //     .multipartUpload(id, file, {
      //       checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
      //       progress: (p, checkpoint, res) => {
      //         //log(p,checkpoint,res)
      //         if (checkpoint) {
      //           _this.fileList[id].progress = p * 100;
      //           _this.fileList[id].data = checkpoint;
      //         }
      //       },
      //       partSize: 1000 * 1024, //设置分片大小
      //       timeout: 120000, //设置超时时间
      //       mime: val.type,
      //     })
      //     .then((res) => {
      //       _this.fileList[id].progress = 100;
      //       _this.fileList[id].uploading = false;
      //       _this.$notify({
      //         title: "上传成功",
      //         message: `${_this.fileList[id].name}上传完成`,
      //         type: "success",
      //       });
      //     })
      //     .catch((err) => {
      //       if (
      //         err.code == "RequestError" ||
      //         err.code == "ConnectionTimeoutError"
      //       ) {
      //         //网络错误或超时
      //         setTimeout(multipartUpload, 3000);
      //       }
      //     });
      // }

      // multipartUpload();
    },
    getTimes(file, id) {
      //获取时长
      let content = file;
      let url = URL.createObjectURL(content);
      let audioElement = new Audio(url);
      let time;
      let _this = this;
      audioElement.addEventListener("loadedmetadata", (_event) => {
        if (!_this.fileList[id].time) {
          this.audioDuration = parseInt(audioElement.duration);
          time = this.audioDuration;
          _this.$set(_this.fileList[id], "time", time);
        }
      });
    },
    handleCurrentChange1(page) {
      this.video_params.page = page;
      this.getVideoData();
    },
    // edit(it) {
    //   this.status = 2;
    //   getDetail(it.tr_id)
    //     .then((res) => {
    //       this.showDia = true;
    //       this.loading1 = false;
    //       let data = res.data;
    //       this.tr_address = it.tr_address;
    //       this.editForm.tr_project_name = data.tr_project_name;
    //       this.editForm.tr_undertaker = data.tr_undertaker;
    //       this.editForm.tr_assist = data.tr_assist;
    //       this.editForm.tr_id = data.tr_id;
    //       this.editForm.tr_type = data.tr_type;
    //       this.editForm.tr_unit_num = data.tr_unit_num;
    //       this.remoteMethod(it.tr_project_name);
    //     })
    //     .catch(() => {
    //       this.loading1 = false;
    //     });
    // },
    // add(it, type) {
    //   this.isread = false;
    //   this.status = 1;
    //   this.showDia = true;
    //   if (type) {
    //     this.isread = true;
    //     this.loading1 = true;
    //     getDetail(it.tr_id)
    //       .then((res) => {
    //         let data = res.data;
    //         this.loading1 = false;
    //         this.tr_address = it.tr_address;
    //         this.form.tr_base.tr_project_name = data.tr_project_name;
    //         this.form.tr_base.tr_undertaker = data.tr_undertaker;
    //         this.form.tr_base.tr_assist = data.tr_assist;
    //         this.form.tr_base.tr_id = data.tr_id;
    //         this.form.tr_base.tr_type = data.tr_type;
    //         this.remoteMethod(it.tr_project_name);
    //       })
    //       .catch(() => {
    //         this.loading1 = false;
    //       });
    //   }
    // },
    add() {
      // this.$post("/dzda/detailxmbg", { xm_uuid: this.$route.query.id }).then(
      //   (res) => {
      //     console.log(res);
      //       var form = {
      //   basebg: {
      //     bg_company_num: res.data.bg_company_num,
      //     starttime: res.data.xm_baogao_time,
      //   },
      //   xiangmubg: {
      //     xm_baogao_leixing:Number( res.data.xm_baogao_leixing),
      //     xm_suoshu:res.data.xm_suoshu,
      //     xm_jiancha_user: res.data.xm_jiancha_user,
      //   },
      //   wenjianbg: [],
      // };
      //   this.form = form
      //   }
      // );
      this.showDia = true;
    },
    handleCurrentChange(page) {
      this.params.page = page;
      this.getList();
    },
    searchSubmit() {
      this.params.page = 1;
      this.params = { ...this.params };
      this.getList();
      this.showdia2 = false;
    },
    formSubmit() {
      let _this = this;

      for (let key in this.fileList) {
        console.log(key);
        let data = this.fileList[key];
        this.form.wenjianbg.push({
          wj_name: data.name,
          wj_lujing: data.url,
        });
      }
      if (this.status === 1) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let params = this.form;
            // this.isUpload = true;
            this.$post("/dzda/addbasebaogao", params).then((res) => {
              console.log(res);
              if (res.code == 200) this.$message.success(res.msg || "操作成功");
              this.showDia = false;
              this.cancleUpload();
              this.getList();
            });
          } else {
            return false;
          }
        });
      } else {
        //修改
        edit(this.editForm).then((res) => {
          this.$message({message: res.msg,type: "success", duration: 700,});
          this.showDia = false;
          this.getList();
        });
      }
    },
    getCitys() {},
    isUpload() {},
  },
  watch: {
    showdia2(val) {
      if (!val) {
        this.resetSearch();
      }
    },
  },
  computed: {
    isUpload() {
      for (let i in this.fileList) {
        if (this.fileList[i].uploading) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-list {
  li {
    position: relative;
    padding: 20px 10px;
    border-bottom: 1px solid #eee;

    img {
      width: 75px;
      margin-right: 15px;
    }

    .el-icon-close {
      position: absolute;
      right: 20px;
      top: 8px;
      cursor: pointer;
    }
  }
}

.mb5 {
  margin-bottom: 5px;
}

.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px !important;
}
</style>